
export function present<T>(value: T): value is Exclude<T, null | undefined | false | ''> {
  if (typeof value == 'string') {
    return value && /\S/.test(value)
  }
  return !!value
}
